import { SET_CURR_USER } from "../actions/action-types";
import { clearUserId, setUserId } from "../utils/analytics";

/**
 * Redux middleware: sync GA4 user_id with auth state.
 * Sets user_id when user signs in, clears when they sign out.
 */
export const analyticsMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === SET_CURR_USER) {
    const user = action.user;
    if (user && user.id) {
      setUserId(String(user.id));
    } else {
      clearUserId();
    }
  }

  return result;
};
